import { fetchCompanyProducts } from '@/features/promo';
import { Env } from '@/shared/config/environment';

const state = {
  companyProducts: null,
  isLoadingCompanyProducts: false,
  companyProductsError: false,
};

const mutations = {
  SET_COMPANY_PRODUCTS: (state, products) => {
    state.companyProducts = products;
  },
  SET_LOADING_COMPANY_PRODUCTS: (state, isLoading) => {
    state.isLoadingCompanyProducts = isLoading;
  },
  SET_COMPANY_PRODUCTS_ERROR: (state, error) => {
    state.companyProductsError = error;
  },
};

const actions = {
  async fetchCompanyProducts({ commit, dispatch }) {
    commit('SET_LOADING_COMPANY_PRODUCTS', true);
    commit('SET_COMPANY_PRODUCTS_ERROR', null);
    commit('SET_COMPANY_PRODUCTS', null);

    try {
      const companyProducts = await fetchCompanyProducts();
      commit('SET_COMPANY_PRODUCTS', companyProducts);

      return companyProducts;
    } catch (error) {
      const errorMessage = error.response?.data?.message
        || error.response?.data?.error
        || error.message
        || 'Не вдалося завантажити список страхових компаній і їх продуктів';

      commit('SET_COMPANY_PRODUCTS_ERROR', errorMessage);
      if (Env.features.showNetworkErrorMessages) {
        dispatch('notificationModule/showNotificationErrorMessage', {
          error: error,
          title: 'Не вдалося завантажити список страхових компаній і їх продуктів',
          message: errorMessage,
        }, { root: true });
      }

      throw error;
    } finally {
      commit('SET_LOADING_COMPANY_PRODUCTS', false);
    }
  },
};

const getters = {
  isLoadingCompanyProducts: state => state.isLoadingCompanyProducts,
  companyProductsError: state => state.companyProductsError,

  isCompanyProductsReady: state => { return state.isLoadingCompanyProducts === false && state.companyProducts !== null; },
  getAllCompaniesWithProducts: state => state.companyProducts?.flatMap(item =>
    item?.companies?.map(company => ({
      ...company
    }))
  ),
  getCompanyProducts: state => insuranceIntermediaryId => {
    const intermediary = state.companyProducts?.find(
      (item) => item.insurance_intermediary?.id === insuranceIntermediaryId
    );

    return intermediary?.companies || [];
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
